<template>
	<div title="Property Information">
		<div class="row">
			<div class="col">
				<h4>{{ question }}</h4>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="contain">
				<b-form-group
					id="fieldset-1"
					description=""
					label=""
					label-for="address">
					<map-box-textbox 
						ref="mb"
						:value="address"
						:search-type="type === 'buy' ? 'place' : 'address'"
						@on-location-selection="locationSelected"
						@on-error="onError"
						@on-blur="onBlur" />
				</b-form-group>
			</div>
		</div>
	</div>
</template>

<script>
import {saveField} from '@/services/apiService';
import {Sources} from '@/config/constants';
import MapBoxTextbox from './input/MapBoxTextbox.vue';
import { setLocationPreferenceBoundingBox } from '@/utils';

export default {
	name: "Address",
	props: ['value', 'source', 'type'],
	components: {
		MapBoxTextbox
	},
	data() {
		return {
			address: this.value,
			location: {},
			question: 'Enter the address of the property you wish to sell'
		}
	},
	methods: {
		locationSelected: function(item) {
			if (this.source === Sources.RDR && !this.location.lat) {
				return;
			}
			if (typeof item.place_name !== 'undefined') {
				this.$emit('input', item.place_name);
				this.$emit('location', { lng: item.geometry.coordinates[0], lat: item.geometry.coordinates[1] });
				saveField('Street', item.place_name);
				setLocationPreferenceBoundingBox(this.type ?? 'sell', item);
			} else {
				const tbxValue = this.$refs.mb.$refs.tbxMapBox.value;
				this.$emit('input', tbxValue);
				saveField('Street', tbxValue);
			}
		},
		onError: function(text) {
			this.$emit('input', text);
		},
		onBlur: function() {
			this.$emit('input', this.$refs.mb.$refs.tbxMapBox.value);
		}
	}
}
</script>

<style scoped>
</style>
